"use strict";

define('controller/logout',['appkit/region.controller', 'backbone'], function (RegionController, Backbone) {
  var LogoutController = RegionController.extend({
    onStart: function onStart() {
      Backbone.history.navigate('');
      this.app.legacyApp.requestLogout();
    }
  });
  return LogoutController;
});

